import { render, staticRenderFns } from "./UserSetting.vue?vue&type=template&id=8bc9f654"
import script from "./UserSetting.vue?vue&type=script&lang=js"
export * from "./UserSetting.vue?vue&type=script&lang=js"
import style0 from "./UserSetting.vue?vue&type=style&index=0&id=8bc9f654&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports